export default __webpack_public_path__ + "static/media/friends.c4543ed7.svg";